<template>
  <div class="py-6">
    <gg-card>
      <gg-card-header>
        <div v-if="isModeManual" class="py-0">
          What would you like to do?
        </div>
        <div v-else>
          Welcome to GreenGeeks Quick Launch Wizard.
        </div>
      </gg-card-header>
      <gg-card-text>
        <div v-if="!isModeManual">
          <p>
            You are now using our Quick Launch Wizard. Simply follow the steps below and you’ll be on your way to
            creating your online presence. If you are not sure what option is best for you, do not hesitate to
            contact our support team to help you.
          </p>

          <p>
            You can always skip this wizard, and come back to it later by
            going to Hosting > Manage $domain > and then clicking Start Wizard.
          </p>
        </div>

        <data-view
          :items="items"
          v-model="selection"
          cols="3"
          svg
        />
      </gg-card-text>
    </gg-card>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { cardActiveStyle } from '@/helpers/wizard'
import DataView from '@/components/Wizard/DataView'

export default {
  name: 'BasicChoice',
  components: {
    DataView
  },
  computed: {
    ...mapGetters({
      items: 'wizard/path',
      serviceName: 'wizard/serviceName',
      mode: 'wizard/mode',
      selected: 'wizard_model/path'
    }),
    selection: {
      get () {
        return this.selected
      },
      set (val) {
        this.setChoice(val)
      }
    },
    isModeManual () {
      return this.mode === 'manual'
    },
  },
  methods: {
    ...mapMutations({
      setChoice: 'wizard_model/SET_BASIC_CHOICE',
      setWizardMode: 'wizard/SET_WIZARD_MODE',
    }),
    cardActiveStyle,
    checkWizardMode () {
      const isModeManual = !!this.$route.query.serviceID
      if (isModeManual) {
        this.setWizardMode('manual')
      }
    },
  },
  mounted () {
    this.checkWizardMode()
  }
}
</script>
